import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/usuarios/usuarios-limitaciones-de-autorizacion-de-contratacion/';

/**
 * GET Lista de Limitaciones de Autorización de Contrataciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getLimitacionesAutorizacionContrataciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Limitación de Autorización de Contrataciones individual
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getLimitacionAutorizacionContrataciones = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Crear Limitación de Autorización de Contrataciones
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postLimitacionAutorizacionContrataciones = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Editar Limitación de Autorización de Contrataciones
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchLimitacionAutorizacionContrataciones = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Eliminar Limitación de Autorización de Contrataciones
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteLimitacionAutorizacionContrataciones = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
